module.exports = __webpack_public_path__ + "static/media/shaketable_3.2209a609.jpg";